import { FormControl } from '@angular/forms';

export function validateEmails(control: FormControl) {
  if (!control.value) {
    return null; // Return null if the field is empty
  }

  const emails = control.value.split(/[,;]/); // Split emails by comma or semicolon

  for (let email of emails) {
    email = email.trim(); // Remove leading/trailing whitespaces

    if (email !== '' && !validateEmail(email)) {
      return { invalidEmail: true };
    }
  }

  return null; // Return null if all emails are valid
}

export function validateEmailsArray(control: FormControl) {
  if (!control.value) {
    return null; // Return null if the field is empty
  }

  const emails = control.value;

  for (let email of emails) {
    email = email.trim(); // Remove leading/trailing whitespaces

    if (email !== '' && !validateEmail(email)) {
      return { invalidEmail: true };
    }
  }

  return null; // Return null if all emails are valid
}

function validateEmail(email: string) {
  // Regex vereist expliciet een punt gevolgd door TLD (2+ letters) aan het einde
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})*$/;
  return emailRegex.test(email);
}
